export default "__VITE_ASSET__9f136739__"